import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $playerPaymentPopupTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('payment_message_header'),
  subtitle: t('content_watched_in_app'),
  button: t('proceed_to_purchase'),
}))
